import { Service, signal } from "@angular/core";

import { ProjectsDashboardFilter } from "../models";

@Service()
export class ProjectsDashboardService {
  currentPage = signal<number>(1);
  filters = signal<ProjectsDashboardFilter | undefined>(undefined);
}
